"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = exports.FEATURE_NAME = void 0;

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/date/now"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _EquizzerService = require("./EquizzerService");

var _BuildConstants = require("../../../../utils/BuildConstants");

var _HttpRequest = require("../../../../utils/HttpRequest");

var _RegisterInstance = _interopRequireDefault(require("../../../../KESI2/Services/RegisterInstance"));

var FEATURE_NAME = 'equeoqd'; // export const DATA_OBJECT_TYPE_GAME = 'EquizzerGame'
// export const DATA_OBJECT_TYPE_GAME_GROUP = 'EquizzerUserGroup'

exports.FEATURE_NAME = FEATURE_NAME;
var DATA_OBJECT_VERSION = 'v2';
var DATA_OBJECTS = 'dataobjects';
var DATA_OBJECT_URL = "mobile/api/".concat(DATA_OBJECTS, "/").concat(DATA_OBJECT_VERSION); // const SERVER_EXCEPTION_ERROR_CODE_REVOKED = 'activation code revoked'
// const SERVER_EXCEPTION_ERROR_DEVICE_NOT_FOUND = 'device not found'
// const SERVER_EXCEPTION_ERROR_DEVICE_LOCKED = 'device locked'
// const SERVER_EXCEPTION_ERROR_PIN_LOCKED = 'pin locked'
// const SERVER_EXCEPTION_ERROR_FORCE_RESYNC = 'force resync'
// const SERVER_EXCEPTION_ERROR_MUST_REVALIDATE = 'must revalidate'
// const SERVER_EXCEPTION_ERROR_MUST_ACTIVATE = 'must activate'
// const SERVER_EXCEPTION_ERROR_CODE_NOT_FOUND = 'code not found'
// const SERVER_EXCEPTION_ERROR_CANNOT_SAVE_USER = 'cannot save user'
// const SERVER_EXCEPTION_ERROR_USERNAME_HAS_WRONG_FORMAT = 'username has the wrong format'
// const SERVER_EXCEPTION_ERROR_NICKNAME_NOT_UNIQUE = 'nickname not unique'
// const SERVER_EXCEPTION_ERROR_PASSWORD_DOESNT_MATCH = 'password doesnt match'
// const SERVER_EXCEPTION_ERROR_ERROR_NO_CONNECTION = 'no internet connection'
// const SERVER_EXCEPTION_ERROR_EMAIL_DUPLICATE = 'email is duplicate'
// const SERVER_EXCEPTION_ERROR_UNSUPPORTED_FEATURE_UPDATE_APP = 'unsupported feature, update app'
// const SERVER_EXCEPTION_FEATURE_ALREADY_ACTIVATED = 'feature already activated'
// const SERVER_EXCEPTION_LEVEL_CLOSED = 'level closed'
// const SERVER_EXCEPTION_ERROR_NO_REQUEST = 'no valid request'
// const SERVER_EXCEPTION_ERROR_REQUEST_TIMEOUT = 'request timeout'
// const SERVER_EXCEPTION_ERROR_PIN_RESET_EXPIRED = 'request expired'
// const SERVER_EXCEPTION_ERROR_NO_USER = 'username doesn\'t exists'

var DataObjectService = {
  getUser: function getUser() {
    return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", (0, _EquizzerService.getUser)());

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  getDataObjects: function getDataObjects() {
    var _arguments = arguments,
        _this = this;

    return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var type, user, oldDate, oldDateUTC, params, response;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              type = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : null;
              console.log('get data objects with ', type);
              _context2.prev = 2;
              _context2.next = 5;
              return _this.getUser();

            case 5:
              user = _context2.sent;
              oldDate = new Date(Date.UTC(1970, 0, 1, 0, 0, 0, 0));
              oldDateUTC = oldDate.toISOString();
              _context2.next = 10;
              return _RegisterInstance["default"].getApplicationInstanceId();

            case 10:
              _context2.t0 = _context2.sent;
              _context2.t1 = user.userName || user.username;
              _context2.t2 = oldDateUTC;
              params = {
                deviceuuid: _context2.t0,
                username: _context2.t1,
                timestamp: _context2.t2
              };
              if (type) params['type'] = type; // if (query) params['query'] = JSON.stringify(query)

              console.log('getDataObjects', params);
              _context2.next = 18;
              return (0, _HttpRequest.httpGet)("".concat(_BuildConstants.HOST, "/").concat(DATA_OBJECT_URL), params);

            case 18:
              response = _context2.sent;

              if (!(response.data.success !== true)) {
                _context2.next = 21;
                break;
              }

              return _context2.abrupt("return", _promise["default"].reject(response));

            case 21:
              return _context2.abrupt("return", _promise["default"].resolve(response));

            case 24:
              _context2.prev = 24;
              _context2.t3 = _context2["catch"](2);
              console.log('ERROR: could not get dataObject', _context2.t3);
              return _context2.abrupt("return", _promise["default"].reject(_context2.t3));

            case 28:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 24]]);
    }))();
  },
  postDataObject: function postDataObject(dataObject) {
    var _this2 = this;

    return (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      var applicationInstanceId, user, now, oldDate, oldDateUTC, nowUTC, list, data, response;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              console.log('post data object');
              _context3.next = 3;
              return _RegisterInstance["default"].getApplicationInstanceId();

            case 3:
              applicationInstanceId = _context3.sent;
              _context3.prev = 4;
              _context3.next = 7;
              return _this2.getUser();

            case 7:
              user = _context3.sent;
              now = new Date((0, _now["default"])());
              oldDate = new Date(Date.UTC(1970, 0, 1, 0, 0, 0, 0));
              oldDateUTC = oldDate.toISOString();
              nowUTC = now.toISOString();
              list = (0, _stringify["default"])([dataObject]);
              _context3.t0 = list;
              _context3.t1 = oldDateUTC;
              _context3.t2 = nowUTC;
              _context3.next = 18;
              return applicationInstanceId;

            case 18:
              _context3.t3 = _context3.sent;
              _context3.t4 = FEATURE_NAME;
              data = {
                dataobjects: _context3.t0,
                timestamp: _context3.t1,
                localtime: _context3.t2,
                deviceuuid: _context3.t3,
                feature: _context3.t4
              };

              if (user) {
                data.username = user.userName || user.username;
              }

              console.log("Post to ".concat(_BuildConstants.HOST, "/").concat(DATA_OBJECT_URL, " with:"), list, oldDateUTC, nowUTC, applicationInstanceId, FEATURE_NAME);
              _context3.next = 25;
              return (0, _HttpRequest.httpPost)("".concat(_BuildConstants.HOST, "/").concat(DATA_OBJECT_URL), data);

            case 25:
              response = _context3.sent;

              if (!(response.data.success !== true)) {
                _context3.next = 28;
                break;
              }

              return _context3.abrupt("return", _promise["default"].reject(response));

            case 28:
              return _context3.abrupt("return", _promise["default"].resolve(response));

            case 31:
              _context3.prev = 31;
              _context3.t5 = _context3["catch"](4);
              console.log('ERROR: could not post data object', _context3.t5);
              return _context3.abrupt("return", _promise["default"].reject(_context3.t5));

            case 35:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[4, 31]]);
    }))();
  }
};
var _default = DataObjectService;
exports["default"] = _default;